<template>
    <div class="searchItemTitle">{{ $t('НМЦ') }}</div>
    <v-container fluid class="pa-0">
        <v-row>
            <v-col cols="6">
                <MoneyInput
                    label="Минимальная"
                    variant="solo"
                    v-model="searchParams.startMaxPrice.from"
                    class="startMaxPriceBlock"
                    single-line
                />
            </v-col>
            <v-col cols="6">
                <MoneyInput
                    label="Максимальная"
                    variant="solo"
                    v-model="searchParams.startMaxPrice.to"
                    class="startMaxPriceBlock"
                    single-line
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import MoneyInput from "@/components/form/MoneyInput";

export default {
    name: 'StartMaxPrice',
    components: {
        MoneyInput
    },
    props: {
        searchParams: {
            type: Object,
            required: true,
            default() {
                return {
                    startMaxPrice: {
                        from: null,
                        to: null,
                    }
                }
            }
        },
    },
}
</script>
<style scoped>
:deep(.v-field--variant-solo, .v-field--variant-solo-filled) {
    border-radius: 6px !important;
    border: 1px solid rgb(var(--grey-border-color)) !important;
    box-shadow: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
:deep(.v-field--variant-solo:hover, .v-field--variant-solo-filled:hover) {
    border-color: rgba(var(--grey-1));
}

:deep(.v-label.v-field-label) {
    color: rgba(var(--black-color), 0.5);
    font-family: var(--primary-font-family-name);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
:deep(.v-input--density-default) {
    --v-input-padding-top: auto;
}
:deep(.v-field__input) {
    padding: 8px;
}
</style>
